module.exports = __webpack_public_path__ + "static/img/tab-logo-gosell.34f6bf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/stores/tab-logo-gosell.png
// module id = U7+o
// module chunks = 134